import { CONVERSATION_OAUTH_CLIENT_CV_PREFIX } from 'src/constants/solve';
import { ConversationOauthClient } from 'src/types/actionBuilderApiTypes';

function convertClientIdToCvId(clientId: string): string {
  return `${CONVERSATION_OAUTH_CLIENT_CV_PREFIX}${clientId.replace(/-/g, '_')}`;
}

export function getUndefinedOauthSignInClientNames({
  oauthClientsData,
  undefinedContextVariableIds,
}: {
  oauthClientsData: ConversationOauthClient[] | undefined;
  undefinedContextVariableIds: string[];
}): string | undefined {
  return oauthClientsData
    ?.filter(client =>
      undefinedContextVariableIds.includes(
        convertClientIdToCvId(client.conversation_oauth_client_id),
      ),
    )
    .map(client => client.name)
    .join(', ');
}
